import { render, staticRenderFns } from "./receiveTransferForm.vue?vue&type=template&id=2c1e9074&"
import script from "./receiveTransferForm.vue?vue&type=script&lang=js&"
export * from "./receiveTransferForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports